import { render } from "./StampModal.vue?vue&type=template&id=8f02f1ec&scoped=true"
import script from "./StampModal.vue?vue&type=script&lang=js"
export * from "./StampModal.vue?vue&type=script&lang=js"

import "./StampModal.vue?vue&type=style&index=0&id=8f02f1ec&rel=scss&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f02f1ec"]])

export default __exports__